import type { Posture } from "./api";

const KEY = "boo.onboarding.posture";

function isPosture(value: unknown): value is Posture {
  return value === "teammate" || value === "chief-of-staff";
}

export const POSTURE_LABELS: Record<Posture, string> = {
  teammate: "Teammate",
  "chief-of-staff": "Chief of staff",
};

// The chief-of-staff entry path is any app link carrying
// ?posture=chief-of-staff (e.g. /signup?posture=chief-of-staff). Runs at
// bootstrap, before the router strips search params it does not validate,
// and keeps the intent in this browser until the container row carries it.
export function captureOnboardingPostureFromUrl(): void {
  try {
    const value = new URL(window.location.href).searchParams.get("posture");
    if (isPosture(value)) localStorage.setItem(KEY, value);
  } catch {
    // No URL or storage access (previews, blocked site data): nothing to keep.
  }
}

export function storedOnboardingPosture(): Posture | null {
  try {
    const value = localStorage.getItem(KEY);
    return isPosture(value) ? value : null;
  } catch {
    return null;
  }
}

export function rememberOnboardingPosture(posture: Posture): void {
  try {
    localStorage.setItem(KEY, posture);
  } catch {
    // Storage blocked: onboarding falls back to teammate.
  }
}

export function clearOnboardingPosture(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // Nothing stored or storage blocked.
  }
}
